import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ProjectDetailsShimmer from '../views/components/ProjectDetailsShimmer';
import SectionWrapper from '../views/components/SectionWrapper';
import { useProjectControllerById } from '../controllers/ProjectsController';
import { FaTimes, FaSearch } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

export default function ProjectDetailView() {
  const { id } = useParams();
  const { t } = useLanguage();
  const { data: project, loading, error } = useProjectControllerById(id);
  const [lightbox, setLightbox] = useState(null);

  if (loading) return <ProjectDetailsShimmer />;
  if (error) return <div className="alert alert-danger">{t('errors.project')}</div>;
  if (!project) return null;

  const name = project.name || '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const last = parts.length > 1 ? parts.pop() : '';
  const first = parts.join(' ') || name;
  const technologies = project.technologies || [];
  const screenshots = project.screenshots || [];

  return (
    <SectionWrapper id="project-detail">
      <div className="project-detail-card mx-auto" data-aos="fade-up">
        <h2 className="project-detail-title">
          {last ? (
            <>
              {first}&nbsp;<span className="highlight">{last}</span>
            </>
          ) : (
            first
          )}
        </h2>

        <p className="project-detail-desc">{project.description}</p>

        {project.image && (
          <img
            src={project.image}
            alt={name}
            className="project-detail-main-img mb-4"
          />
        )}

        <div className="tech-badges mb-4">
          {technologies.map(tech => (
            <span key={tech} className="badge tech-badge me-2 mb-2">
              {tech}
            </span>
          ))}
        </div>

        {screenshots.length > 0 && (
          <>
            <h5 className="mb-3">{t('projectDetail.screenshots')}</h5>
            <div className="row g-4 project-screenshots">
              {screenshots.map((src, idx) => (
                <div key={src || idx} className="col-12 col-md-6">
                  <div
                    className="screenshot-container"
                    onClick={() => setLightbox(src)}
                  >
                    <img
                      src={src}
                      alt={t('projectDetail.screenshotAlt', {
                        name,
                        number: idx + 1,
                      })}
                      className="screenshot-img"
                    />
                    <FaSearch className="screenshot-icon" />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="mt-5">
          <Link to="/projects" className="text-decoration-none">
            <span aria-hidden="true">&larr;</span> {t('projectDetail.back')}
          </Link>
        </div>
      </div>

      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <button
            className="lightbox-close"
            onClick={() => setLightbox(null)}
            aria-label={t('common.close')}
          >
            <FaTimes />
          </button>
          <img
            src={lightbox}
            alt={t('projectDetail.enlargedAlt')}
            className="lightbox-image"
          />
        </div>
      )}
    </SectionWrapper>
  );
}
